var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// material
import { Box, Stack } from "@mui/material";
//import Circle from "@mui/icons-material/Circle";
// say
import { COLORS } from "../../../../../constants/colors";
import { useMemo } from "react";
import CheckCircleIcon from "../CheckCircleIcon";
var color = COLORS.SAY_COBALT;
var Circle = function (_a) {
    var size = _a.size, color = _a.color;
    return (_jsx(Box, { bgcolor: color, width: size, height: size, borderRadius: "50%" }));
};
var StepIndicator = function (_a) {
    var currentStep = _a.currentStep, idx = _a.idx, step = _a.step, previousStep = _a.previousStep;
    var stepElement = useMemo(function () {
        // if its a past step or marked complete, show complete state
        if (currentStep > idx || step.complete) {
            return _jsx(CheckCircleIcon, { "data-testid": "step-".concat(idx, "-past") });
        }
        // if current step, and not complete(above) show blue bullet
        if (currentStep === idx || (previousStep === null || previousStep === void 0 ? void 0 : previousStep.complete)) {
            return (_jsx(Box, __assign({ display: "flex", sx: {
                    backgroundColor: color,
                    borderRadius: "50%",
                    width: "20px",
                    height: "20px",
                    alignItems: "center",
                    justifyContent: "center",
                    m: 0.5,
                } }, { children: _jsx(Circle, { color: COLORS.WHITE, size: 6 }) })));
        }
        return (_jsx(Stack, __assign({ height: 24, mx: 0.5, justifyContent: "center" }, { children: _jsx(Circle, { size: 12, color: COLORS.P_DISABLED }) })));
    }, [currentStep, step.complete, previousStep]);
    return _jsx(Box, { children: stepElement });
};
export default StepIndicator;
